module.exports = __webpack_public_path__ + "img/avatar-tool-intro.5743f56.png";